// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"99534122f11911c8","646":"1d17e60c765a6025"}[chunkId] + ".css";
};